var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("ValidationProvider", {
    attrs: { rules: _vm.validationRules, tag: "div" },
    scopedSlots: _vm._u([
      {
        key: "default",
        fn: function ({ errors }) {
          return [
            _c(
              "div",
              {
                class: [
                  { "error-styles": errors[0] },
                  { "disabled-field": _vm.disabled },
                  "lf-file-upload-container",
                ],
              },
              [
                _c(
                  "span",
                  {
                    class: [
                      { "required-field": _vm.requiredField },
                      "label-text",
                    ],
                  },
                  [_vm._v(_vm._s(_vm.$attrs.label))]
                ),
                _c(
                  "div",
                  { staticClass: "lf-file-upload" },
                  [
                    _c("v-file-input", {
                      class: [
                        { "error-styles": errors[0] },
                        "lf-file-upload-input",
                      ],
                      attrs: {
                        id: "fileUpload",
                        label: _vm.innerValue,
                        disabled: _vm.disabled,
                        placeholder: _vm.placeHolder,
                        clearable: false,
                        value: _vm.fileValue,
                        "single-line": "",
                      },
                      on: { change: _vm.onFileChange },
                    }),
                  ],
                  1
                ),
                _c("div", { staticClass: "messages-container" }, [
                  _c("div", { staticClass: "messages" }, [
                    errors.length
                      ? _c("span", { staticClass: "alert-message" }, [
                          _vm._v(_vm._s(errors[0])),
                        ])
                      : _c("span", { staticClass: "help-message" }, [
                          _vm._v(_vm._s(_vm.helpText)),
                        ]),
                  ]),
                ]),
              ]
            ),
            _vm.showPreview && _vm.fileValue
              ? _c(
                  "div",
                  { staticClass: "lf-file-preview" },
                  [_c("v-img", { attrs: { src: _vm.previewImage } })],
                  1
                )
              : _vm._e(),
            _vm.showPreview && _vm.fileValue
              ? _c(
                  "div",
                  {
                    staticClass: "clear-field-button",
                    on: { click: _vm.clearField },
                  },
                  [
                    _c("span", { class: `${_vm.removeIcon} clear-field-icon` }),
                    _c("span", { staticClass: "clear-field-label" }, [
                      _vm._v(_vm._s(_vm.clearFieldText)),
                    ]),
                  ]
                )
              : _vm._e(),
          ]
        },
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }